import {
  BookOpen,
  Box,
  Braces,
  Cloud,
  Cpu,
  Database,
  Layers,
  Lock,
  Radio,
  Server,
  Settings2,
  Users,
  Zap,
} from "lucide-react";

export interface DocsPageEntry {
  slug: string;
  label: string;
  icon: typeof BookOpen;
  status?: "Preview";
}

export interface DocsSection {
  label: string;
  items: DocsPageEntry[];
}

/** Single source of truth for docs sidebar nav, breadcrumbs, and route registration. */
export const DOCS_SECTIONS: DocsSection[] = [
  {
    label: "Getting Started",
    items: [
      { slug: "", label: "Introduction", icon: BookOpen },
      { slug: "quickstart", label: "Quickstart", icon: Zap },
      { slug: "core-concepts", label: "Core concepts", icon: Layers },
    ],
  },
  {
    label: "Realtime",
    items: [
      { slug: "sessions", label: "Sessions", icon: Users },
      { slug: "events", label: "Events", icon: Radio },
      {
        slug: "spatial-subspaces",
        label: "Spatial Subspaces",
        icon: Box,
      },
    ],
  },
  {
    label: "Platform",
    items: [
      {
        slug: "persistent-state",
        label: "Persistence",
        icon: Database,
        status: "Preview",
      },
      { slug: "inference-network", label: "Inference", icon: Cpu, status: "Preview" },
      { slug: "authentication", label: "Authentication", icon: Lock },
    ],
  },
  {
    label: "Clients",
    items: [
      { slug: "sdks/rust", label: "Rust", icon: Settings2 },
      { slug: "sdks/javascript", label: "TypeScript", icon: Braces },
    ],
  },
  {
    label: "Deploy",
    items: [
      { slug: "deploy/self-hosting", label: "Self-hosting", icon: Server },
      { slug: "deploy/woven-host", label: "Woven Host", icon: Cloud },
    ],
  },
];

export function docsPath(slug: string): string {
  return slug ? `/docs/${slug}` : "/docs";
}

export interface DocsSearchEntry extends DocsPageEntry {
  section: string;
}

/** Flattened, searchable index of every doc page — titles/sections only, no fabricated body text. */
export const DOCS_SEARCH_INDEX: DocsSearchEntry[] = DOCS_SECTIONS.flatMap((section) =>
  section.items.map((item) => ({ ...item, section: section.label }))
);

export interface DocsTocEntry {
  id: string;
  label: string;
}

/** Keyed by slug; entries must match heading IDs rendered by the page. */
export const DOCS_TOC: Record<string, DocsTocEntry[]> = {
  "": [
    {
      id: "what-is-woven-host",
      label: "Realtime sessions, managed with WOVEN Host.",
    },
    { id: "available-now", label: "What is available now" },
    { id: "get-started", label: "Get started" },
    { id: "client-support", label: "Client support" },
    { id: "preview", label: "Preview scope" },
  ],
};
